export default __webpack_public_path__ + "static/media/we2.67951f98.png";